import React, { Fragment } from 'react';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
//import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Button from '../../components/UI/CustomButtons/Button';

import filterStyle from '../../assets/jss/coscef/views/filterStyle';

const useStyles = makeStyles(filterStyle);

const Paginate = (props) => {
  const classes = useStyles();

  const onPaginaSiguienteHandler = (event) => {
    event.preventDefault();
    props.paginaSiguiente(props.cursorFinal);
  };

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <div className={classes.moveTo}>
            {/* <Button color='dark' round disabled={!false}>
              <KeyboardArrowLeft />
              anterior
            </Button>{' '} */}
            <Button
              color='dark'
              round
              onClick={onPaginaSiguienteHandler}
              disabled={!props.tienePaginaSiguiente}
            >
              siguiente
              <KeyboardArrowRight />
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
};

export default Paginate;
